import React, { Fragment, useCallback, useState } from "react";

import {
  Container,
  Hoverable,
  ImageGalleryModal,
  Pressable,
} from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";
import { ImageGalleryProps } from "./image_gallery_mobile";
import { Spacer } from "./spacer";
import { Text } from "./text";
import { useAnalytics } from "../lib/analytics/analytics";

const height = 451;

export function ImageGalleryDesktop(props: ImageGalleryProps) {
  const { images, name, imagesModal, featuredPromoRibbon } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const { fbt, locale } = useI18n();
  const items = (imagesModal ? imagesModal : images).map((image) => ({
    src: image.url,
    w: image.width,
    h: image.height,
    width: "100%",
  }));

  const analytics = useAnalytics();

  const handleOpen = useCallback(
    (index) => {
      setIsOpen(true);
      setIndex(index);

      analytics.event(
        "Images Click",
        {
          Source: "WL",
        },
        { onlyProviders: ["mixpanel", "customerio"] }
      );
    },
    [analytics]
  );

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (images.length === 0) {
    return (
      <div
        style={{
          height,
          boxSizing: "border-box",
          display: "flex",
          position: "relative",
        }}
      />
    );
  }

  return (
    <>
      <Hoverable>
        {(hovered) => (
          <div style={{ position: "relative" }}>
            <div
              style={{
                height,
                boxSizing: "border-box",
                display: "flex",
                position: "relative",
              }}
            >
              <div
                style={{
                  width:
                    images.length >= 3
                      ? "66.6667%"
                      : images.length === 2
                      ? "50%"
                      : "100%",

                  ...(locale.direction === "ltr"
                    ? {
                        paddingLeft: 16,
                        paddingRight: images.length >= 2 ? 8 : 16,
                      }
                    : {
                        paddingRight: 16,
                        paddingLeft: images.length >= 2 ? 8 : 16,
                      }),
                  boxSizing: "border-box",
                }}
              >
                <Pressable
                  style={{ width: "100%" }}
                  onPress={() => handleOpen(0)}
                >
                  <Container overflow="hidden">
                    {featuredPromoRibbon}
                    <img
                      src={images[0].url}
                      alt={`${name} cover 1`}
                      style={{
                        objectFit: "cover",
                        height,
                        width: "100%",
                      }}
                    />
                  </Container>
                </Pressable>
              </div>
              {images.length === 2 && (
                <Fragment>
                  <div
                    style={{
                      width: "50%",
                      ...(locale.direction === "ltr"
                        ? {
                            paddingLeft: 8,
                            paddingRight: 16,
                          }
                        : {
                            paddingRight: 8,
                            paddingLeft: 16,
                          }),
                      boxSizing: "border-box",
                    }}
                  >
                    <Pressable
                      style={{ width: "100%" }}
                      onPress={() => handleOpen(1)}
                    >
                      <img
                        src={images[1].url}
                        alt={`${name} cover 2`}
                        style={{
                          objectFit: "cover",
                          height,
                          width: "100%",
                        }}
                      />
                    </Pressable>
                  </div>
                </Fragment>
              )}
              {images.length >= 3 && (
                <>
                  <div
                    style={{
                      width: "33.333%",
                      boxSizing: "border-box",
                      ...(locale.direction === "ltr"
                        ? {
                            paddingRight: 16,
                          }
                        : {
                            paddingLeft: 16,
                          }),
                    }}
                  >
                    <div>
                      <Pressable
                        style={{
                          height: (height - 8) / 2,
                          width: "100%",
                        }}
                        onPress={() => handleOpen(1)}
                      >
                        <img
                          src={images[1].url}
                          alt={`${name} cover 2`}
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </Pressable>
                      <Spacer size={8} />
                      <Pressable
                        style={{
                          height: (height - 8) / 2,
                          width: "100%",
                        }}
                        onPress={() => handleOpen(2)}
                      >
                        <img
                          src={images[2].url}
                          alt={`${name} cover 3`}
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </Pressable>
                    </div>
                  </div>
                </>
              )}
            </div>
            {hovered && (
              <div
                style={{
                  position: "absolute",
                  bottom: 8,
                  ...(locale.direction === "ltr"
                    ? { right: 24 }
                    : { left: 24 }),
                }}
              >
                <Pressable onPress={() => handleOpen(0)}>
                  <div
                    style={{
                      borderRadius: 4,
                      backgroundColor: "white",
                      padding: 16,
                    }}
                    className="all-images-button"
                  >
                    <Text>{fbt("View all images")}</Text>
                  </div>
                </Pressable>
              </div>
            )}
          </div>
        )}
      </Hoverable>
      <ImageGalleryModal
        isOpen={isOpen}
        index={index}
        items={items}
        onClose={handleClose}
      />
    </>
  );
}
